// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__qE7gA","subheader":"ReorderModal_subheader__3-Vv8","listWrap":"ReorderModal_listWrap__MHmtJ"};